/* Remember an explicit protection choice while navigating this storefront. */
(()=>{
  const selector='cart-drawer-upsell[data-handle="shipping-protection"]';
  const key='loxhaven-shipping-protection-choice';
  let choice=null;try{choice=sessionStorage.getItem(key);}catch(error){}
  document.querySelectorAll(selector).forEach(upsell=>{
    if(choice!==null)upsell.dataset.selected=choice;
    upsell.querySelector('.upsell-toggle-btn')?.setAttribute('aria-label','Shipping Protection');
  });
  document.addEventListener('click',event=>{
    const button=event.target.closest('.upsell-toggle-btn');
    const upsell=button?.closest(selector);if(!upsell)return;
    try{sessionStorage.setItem(key,String(upsell.dataset.selected!=='true'));}catch(error){}
  },true);
})();

/* Each selected offer is one Shopify variant with its final pack price. */
if (!customElements.get('loxhaven-pack-picker')) customElements.define('loxhaven-pack-picker', class extends HTMLElement {
  connectedCallback() {
    if(this.ready)return;this.ready=true;
    this.variants=JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.addEventListener('change',()=>this.sync());
    const bindSticky=()=>{
    const sticky=document.getElementById('sticky-atc-'+this.dataset.section);
    if(!sticky||this.boundSticky===sticky)return;
    this.boundSticky=sticky;
    sticky?.addEventListener('click',event=>{
      if(!event.target.closest('.sticky-atc__add_button')||sticky.dataset.scrollBtn==='true')return;
      event.preventDefault();event.stopImmediatePropagation();this.sync();
      document.getElementById(this.dataset.form)?.querySelector('button[name="add"]')?.click();
    },true);
    sticky?.addEventListener('change',event=>{
      if(!event.target.matches('select'))return;
      event.stopImmediatePropagation();
      const option=event.target.selectedOptions[0];
      const variant=this.variants.find(v=>String(v.id)===option.dataset.variantId||v.option1===event.target.value);
      if(variant){this.selectVariant(variant);this.sync();}
    },true);
    };
    bindSticky();
    if(this.dataset.eyeBundle==='true'){
      queueMicrotask(bindSticky);
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bindSticky,{once:true});
    }
    const requested=new URL(location.href).searchParams.get('variant');
    const variant=this.variants.find(v=>String(v.id)===requested);
    if(variant)this.selectVariant(variant);
    this.sync();
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>this.sync(),{once:true});
  }
  selectVariant(variant){
    const q=parseInt(variant.option1,10),card=this.querySelector(`[data-size="${q}"]`);
    if(!card)return;
    card.querySelector('input[type="radio"]').checked=true;
    const black=Number((variant.option1.match(/(\d+) Black/)||[])[1]||0);
    card.querySelectorAll('select').forEach((select,i)=>select.value=i<black?'Black':'Brown');
  }
  sync(){
    const q=Number(this.querySelector('input[type="radio"]:checked').value);
    const card=this.querySelector(`[data-size="${q}"]`);
    this.querySelectorAll('.loxhaven-pack').forEach(c=>c.classList.toggle('is-selected',c===card));
    const black=[...card.querySelectorAll('select')].filter(s=>s.value==='Black').length;
    const variant=this.variants.find(v=>parseInt(v.option1,10)===q &&
      (this.dataset.mascara!=='true'||Number((v.option1.match(/(\d+) Black/)||[])[1]||0)===black));
    if(!variant)return;
    const form=document.getElementById(this.dataset.form);
    if(form){
      const id=form.querySelector('[name="id"]');if(id){id.value=variant.id;id.disabled=false;}
      form.querySelectorAll('[name="selling_plan"]').forEach(i=>i.disabled=true);
    }
    const installment=document.getElementById('product-form-installment-'+this.dataset.section);
    if(installment?.querySelector('[name="id"]'))installment.querySelector('[name="id"]').value=variant.id;
    const money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency||'USD'});
    const info=document.getElementById('ProductInfo-'+this.dataset.section)||this.closest('section');
    const sticky=document.getElementById('sticky-atc-'+this.dataset.section);
    const prices=[document.getElementById('price-'+this.dataset.section),sticky];
    prices.forEach(price=>{
      price?.querySelectorAll('.price-item--regular,.price-item--sale').forEach(el=>el.textContent=money.format(((el.matches('s')||el.closest('s'))?variant.compare_at_price:variant.price)/100));
      price?.querySelectorAll('.badge__percentage-saved').forEach(el=>el.textContent=Math.max(0,Math.floor((variant.compare_at_price-variant.price)*100/variant.compare_at_price)));
      price?.querySelectorAll('.badge__money-saved').forEach(el=>el.textContent=money.format((variant.compare_at_price-variant.price)/100));
    });
    sticky?.querySelectorAll('select').forEach(select=>{
      const option=[...select.options].find(o=>String(o.dataset.variantId)===String(variant.id)||o.value===variant.option1);
      if(option)select.value=option.value;
    });
    info?.querySelectorAll('button[name="add"]').forEach(b=>{b.disabled=!variant.available;b.setAttribute('aria-disabled',String(!variant.available));});
    this.dataset.selectedVariant=variant.id;
  }
});

/* Shrine cart updates count the real tubes. Replace archived Eye Gel bundles in existing carts with the active variants. */
(()=>{
 const legacy={'47563191386284':47275256512684,'47563191419052':47275256545452};
 const pendingQuantities=new Set();
 let migration=null,migrationLocked=false,checkoutPending=false,resume=false;
 const root=window.Shopify?.routes?.root||'/';
 const checkoutSelector='button[name="checkout"],input[name="checkout"],a[href^="/checkout"],a[href^="'+root+'checkout"]';
 const blockedSelector='cart-items,cart-drawer-items,product-form,.sticky-atc__add_button,button[name="add"]';
 function trackQuantity(pending){
  const promise=Promise.resolve(pending);
  pendingQuantities.add(promise);
  promise.then(()=>pendingQuantities.delete(promise),()=>pendingQuantities.delete(promise));
  return promise;
 }
 customElements.whenDefined('cart-items').then(()=>{
  const prototype=customElements.get('cart-items').prototype,update=prototype.updateQuantity;
  prototype.updateQuantity=function(...args){return trackQuantity(update.apply(this,args));};
 });
 async function waitQuantities(){
  while(pendingQuantities.size)await Promise.all([...pendingQuantities]);
 }
 function updateHeader(cart){
  const header=document.getElementById('loxhaven-header-cart');if(!header)return;
  const markup=cart?.sections?.['cart-icon-bubble'];
  const scope=markup?new DOMParser().parseFromString(markup,'text/html'):document.getElementById('cart-icon-bubble');
  if(!scope)return;
  const bubble=scope.querySelector('.cart-count-bubble');
  const count=bubble?.dataset.unitCount||bubble?.querySelector('span[aria-hidden="true"]')?.textContent.trim();
  header.textContent=count&&Number(count)>0?'Cart ('+count+')':'Cart';
 }
 function cartRenderers(){
  return [...document.querySelectorAll('cart-drawer-items,cart-items')].flatMap(cart=>
   typeof cart.getSectionsToRender==='function'?cart.getSectionsToRender().map(section=>({cart,...section})):[]);
 }
 function renderCart(cartData,renderers){
  for(const section of renderers){
   const markup=cartData.sections?.[section.section],container=document.getElementById(section.id);
   if(!markup||!container)continue;
   const target=container.querySelector(section.selector)||container;
   target.innerHTML=section.cart.getSectionInnerHTML(markup,section.selector);
  }
  updateHeader(cartData);
 }
 async function migrate(){
  migrationLocked=true;
  const locked=[...document.querySelectorAll('cart-items,cart-drawer-items,product-form')].map(element=>({element,inert:element.inert}));
  locked.forEach(({element})=>{element.inert=true;});
  try{
   await waitQuantities();
   if(!document.querySelector(Object.keys(legacy).map(id=>'[data-quantity-variant-id="'+id+'"] ').join(',')))return;
   const beforeResponse=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});
   if(!beforeResponse.ok)throw new Error('Please re-add Eye Gel before checking out.');
   const before=await beforeResponse.json(),old=before.items.filter(item=>legacy[String(item.variant_id)]);
   if(!old.length)return;
   if(old.some(item=>Object.keys(item.properties||{}).length))throw new Error('Please re-add Eye Gel before checking out.');
   const updates={},expected={};
   for(const id of new Set(old.map(item=>legacy[String(item.variant_id)]))){
    const existing=before.items.filter(item=>item.variant_id===id);
    if(existing.length>1||existing.some(item=>Object.keys(item.properties||{}).length))throw new Error('Please re-add Eye Gel before checking out.');
    const count=(existing[0]?.quantity||0)+old.filter(item=>legacy[String(item.variant_id)]===id).reduce((sum,item)=>sum+item.quantity,0);
    updates[existing[0]?.key||String(id)]=count;expected[id]=count;
   }
   old.forEach(item=>{updates[item.key]=0;});
   const renderers=cartRenderers(),sections=[...new Set(['cart-icon-bubble',...renderers.map(section=>section.section)])];
   const response=await fetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates,sections,sections_url:location.pathname})});
   if(!response.ok)throw new Error('Please re-add Eye Gel before checking out.');
   const after=await response.json();
   if(after.items.some(item=>legacy[String(item.variant_id)])||Object.entries(expected).some(([id,count])=>after.items.filter(item=>String(item.variant_id)===id).reduce((sum,item)=>sum+item.quantity,0)!==count))throw new Error('Please re-add Eye Gel before checking out.');
   if(sections.some(section=>!after.sections?.[section])){
    const sectionsResponse=await fetch(root+'cart?sections='+sections.join(','),{credentials:'same-origin',cache:'no-store'});
    if(!sectionsResponse.ok)throw new Error('Please refresh your cart before checking out.');
    after.sections=await sectionsResponse.json();
    if(sections.some(section=>!after.sections?.[section]))throw new Error('Please refresh your cart before checking out.');
   }
   renderCart(after,renderers);
  }finally{
   locked.forEach(({element,inert})=>{if(element.isConnected)element.inert=inert;});
   migrationLocked=false;
  }
 }
 const ensure=()=>migration||(migration=migrate().finally(()=>{migration=null;}));
 function liveCheckout(snapshot){
  if(snapshot.id){const element=document.getElementById(snapshot.id);if(element?.matches(checkoutSelector))return element;}
  if(snapshot.formId){const element=document.getElementById(snapshot.formId)?.querySelector(checkoutSelector);if(element)return element;}
  if(snapshot.href)return [...document.querySelectorAll(checkoutSelector)].find(element=>element.getAttribute('href')===snapshot.href);
  return document.querySelector(snapshot.drawer?'cart-drawer '+checkoutSelector.split(',').join(',cart-drawer '):checkoutSelector);
 }
 async function proceedCheckout(checkout){
  if(checkoutPending)return;checkoutPending=true;
  const snapshot={id:checkout.id,formId:checkout.form?.id,href:checkout.getAttribute('href'),drawer:!!checkout.closest('cart-drawer')};
  try{
   await waitQuantities();await ensure();await waitQuantities();
   const current=liveCheckout(snapshot);
   if(!current)throw new Error('Please refresh your cart before checking out.');
   resume=true;current.click();
  }catch(error){alert(error.message);}finally{resume=false;checkoutPending=false;}
 }
 document.addEventListener('change',event=>{
  const input=event.target.closest?.('input[data-eye-units-per-pack]');
  if(migrationLocked&&event.target.closest?.(blockedSelector)){
   event.stopImmediatePropagation();event.preventDefault();
   if(input)input.value=input.getAttribute('value');return;
  }
  if(!input)return;
  event.stopImmediatePropagation();
  const units=Number(input.dataset.eyeUnitsPerPack),quantity=Number(input.value);
  if(!Number.isInteger(quantity)||quantity<0||quantity%units!==0||!input.checkValidity()){input.reportValidity();return;}
  const cart=input.closest('cart-drawer-items,cart-items');
  if(typeof cart?.updateQuantity==='function'){
   const disabled=input.disabled;input.disabled=true;input.value=String(quantity/units);
   trackQuantity(Promise.resolve(cart.updateQuantity(input.dataset.index,quantity/units,'eye-unit-count')).finally(()=>{
    if(input.isConnected){input.value=input.getAttribute('value');input.disabled=disabled;}
   }));
  }
 },true);
 document.addEventListener('click',event=>{
  const checkout=event.target.closest?.(checkoutSelector);
  if(checkout&&!resume){event.preventDefault();event.stopImmediatePropagation();proceedCheckout(checkout);return;}
  if(migrationLocked&&!resume&&event.target.closest?.(blockedSelector)){event.preventDefault();event.stopImmediatePropagation();}
 },true);
 document.addEventListener('submit',event=>{
  if(resume)return;
  const checkout=event.submitter?.matches(checkoutSelector)?event.submitter:event.target.querySelector(checkoutSelector);
  if(!checkout)return;
  event.preventDefault();event.stopImmediatePropagation();proceedCheckout(checkout);
 },true);
 document.addEventListener('DOMContentLoaded',()=>{
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,event=>updateHeader(event.cartData));
  ensure().catch(()=>{});
 },{once:true});
})();
